import { render } from "./Entitlement.vue?vue&type=template&id=632af68a"
import script from "./Entitlement.vue?vue&type=script&lang=js"
export * from "./Entitlement.vue?vue&type=script&lang=js"

import "./Entitlement.vue?vue&type=style&index=0&id=632af68a&lang=css"

import exportComponent from "/Users/abinop/code/Filisia-Dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__